<div class="menu-block-wrap">
  <div class="menu-block" [ngClass]="{ opened: isOpen }">
    <div class="logo">
      <svg-icon name="logo-mini" class="mini"></svg-icon>
      <svg-icon name="logo" class="big"></svg-icon>

      <div class="menu-switcher" (click)="onOpen(); false">
        <svg viewBox="0 0 7 12">
          <use class="open" href="#arrow_right" />
          <use class="close" href="#arrow_left" />
        </svg>
      </div>
    </div>
    <div class="menu-list">
      <div
        class="menu-item"
        routerLink="/home"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="icon-wrap">
          <svg viewBox="0 0 18 18">
            <use href="#home" />
          </svg>
        </div>
        <div class="menu-item-title">Home</div>
      </div>
      <div
        class="menu-item"
        routerLink="/dashboard"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="icon-wrap">
          <svg viewBox="0 0 18 18">
            <use href="#dashboard" />
          </svg>
        </div>
        <div class="menu-item-title">Dashboard</div>
      </div>
      <div
        class="menu-item"
        routerLink="/past-meetings"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <div class="icon-wrap">
          <svg-icon name="previous"></svg-icon>
        </div>
        <div class="menu-item-title">Past meetings</div>
      </div>
    </div>
    <div class="menu-list menu-list-bottom">
      <!-- TODO: special hightlight -->
      <div class="menu-item" routerLink="/walls" [routerLinkActive]="['active']">
        <div class="icon-wrap">
          <!-- TODO: update icon -->
          <svg-icon name="console"></svg-icon>
        </div>
        <div class="menu-item-title">Walls</div>
      </div>
      <div class="menu-item" routerLink="/console" [routerLinkActive]="['active']" *ngIf="withConsole">
        <div class="icon-wrap">
          <svg-icon name="console"></svg-icon>
        </div>
        <div class="menu-item-title">Console</div>
      </div>
      <div class="menu-item" routerLink="/settings" [routerLinkActive]="['active']">
        <div class="icon-wrap">
          <svg viewBox="0 0 20 20">
            <use href="#settings_menu_icon" />
          </svg>
        </div>
        <div class="menu-item-title">Settings</div>
      </div>
      <div class="menu-item" (click)="onLogout(); (false)">
        <div class="icon-wrap">
          <svg viewBox="0 0 20 20">
            <use href="#logout" />
          </svg>
        </div>
        <div class="menu-item-title">Log out</div>
      </div>
    </div>
    <div class="menu-version" *ngIf="versionLabel as label" [title]="label">Build {{ label }}</div>
  </div>
</div>
